import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/winningRecord',
  component: LAYOUT,
  name: 'winningRecord',
  redirect: '/winningRecord/index',
  meta: {
    title: '活动订单',
  },
  children: [
    {
      path: 'index',
      name: 'WinningRecord',
      meta: {
        title: '活动订单',
      },
      component: () => import('@/views/winningRecord/index.vue'),
    },
    {
      path: 'drawDetail',
      name: 'DrawDetail',
      meta: {
        title: '领取详情',
      },
      component: () => import('@/views/winningRecord/drawDetail.vue'),
    },
    {
      path: 'drawSuccess',
      name: 'DrawSuccess',
      meta: {
        title: '领取成功',
      },
      component: () => import('@/views/winningRecord/drawSuccess.vue'),
    },
    {
      path: 'drawPrize',
      name: 'DrawPrize',
      meta: {
        title: '奖品领取',
      },
      component: () => import('@/views/winningRecord/drawPrize.vue'),
    },
  ],
};
